import { ContractLengthAction } from '../actions/ContractLengthAction'
import { SequenceManagerAction } from "../actions/SequenceManagerAction";

const initState = {
    requestBody: {
        sectionId: "contractLength",
        steps: [
            {
                sequence: "0",
                offerContainerId: "",
                stepId: "contractLengthDetails",
                options: [
                    {
                        name: "contractLength",
                        value: ""
                    }
                ]
            }
        ]
    },
}

const ContractLengthReducer = (state: any = initState, action: any) => {
    const { type } = action;
    const { payload } = action;
    var NumberValue = { ...state.requestBody.steps };

    switch (type) {
        case ContractLengthAction.MONTHS_SELECTION:
            NumberValue[0].options[0].value = payload.selection;
            NumberValue[0].offerContainerId = payload.offerContainerId;
            return state;

        case SequenceManagerAction.GET_CHECKOUT_SUCCESS:
            let section = payload.sections.filter((section: any) => {
                return (section.sectionId === 'contractLength')
            });
            if (section.length > 0) {
                let contractMonths = section[0].steps[0].options[0]
                NumberValue[0].offerContainerId = section[0].steps[0].offerContainerId;
                NumberValue[0].options[0].value = contractMonths ? contractMonths.value : "";
            }
            return state;

        default:
            return state;
    }
}

export default ContractLengthReducer;